import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { NAME_REGEX } from 'common-constants/validation';

const InputLastName = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="lastName"
      control={control}
      defaultValue={prefill}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: NAME_REGEX,
          message: 'Last name can only contain alphabetic, and certain special characters (\',-, ).',
        },
      }}
    >
      <TextField fullWidth label="Last Name" />
    </ValidatedTextField>
  );
};

export default InputLastName;
